<template>
  <div style="padding-top: 16px" id="page-container">
    <div class="page-section jobs_container">
      <div :class="containerClass">
        <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-24pt" style="white-space: nowrap">
          <h2 class="mb-0">Licenses</h2>

          <div class="w-auto ml-sm-auto mb-sm-0" :class="{ 'd-flex': !isMobileScreen }">
            <div :class="isMobileScreen ? 'mt-2 ml-auto' : 'ml-3'">
              <b-btn :to="{ name: 'add-license' }" variant="primary" :class="{ 'w-100': isMobileScreen }"
                >Add a License</b-btn
              >
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center" v-if="!total && !isLoading">
          <div class="card card-block card-stretch card-height col-md-12">
            <div class="card-body text-center">
              <i class="fas fa-exclamation-circle fa-lg text-muted mt-4 mb-4" style="font-size: 3rem" />
              <h4>No Licenses</h4>
              <p class="text-muted">Couldn't find any licenses right now.</p>
            </div>
          </div>
        </div>

        <div class="card mb-0" v-if="total">
          <b-table
            :fields="tableColumns"
            :items="items"
            :busy="isLoading"
            head-variant="light"
            class="table-nowrap"
            hover
            responsive
            no-local-sorting
          >
            <template #head(actions)=""><span></span></template>
            <template #cell(actions)="data">
              <router-link
                :to="{ name: 'edit-license', params: { id: data.item.id } }"
                class="svg-icon mr-2"
                v-b-popover.hover.right
                :title="'Edit'"
              >
                <i class="material-icons">edit</i>
              </router-link>
            </template>
          </b-table>

          <div class="card-footer">
            <pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="perPage"
              @change="onPageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue';
import Pagination from '../../../components/Ui/Pagination.vue';
import { mapActions } from 'vuex';

export default {
  components: { Pagination },
  extends: Page,

  data() {
    return {
      title: 'Licenses',
      isLoading: true,
      perPage: 14,
      currentPage: 1,
      total: 0,
      items: [],
      windowWidth: window.innerWidth,
    };
  },

  computed: {
    tableColumns() {
      return [
        { key: 'license_other', label: 'License' },
        { key: 'issuing_authority', label: 'Issuing Authority' },
        { key: 'year_of_issue', label: 'Year of Issue' },
        { key: 'expiry_date', label: 'Expiry Date' },
        { key: 'actions', tdClass: 'text-right', thStyle: { minWidth: '100px' } },
      ];
    },
    isMobileScreen() {
      return this.windowWidth <= 720;
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    ...mapActions('student', ['getAllLicenses']),

    async fetchItems(pageNum = 1, params = {}) {
      this.isLoading = true;
      const response = await this.getAllLicenses({
        limit: this.perPage,
        offset: (pageNum - 1) * this.perPage,
        ...params,
      });
      this.items = response.data.results;
      this.currentPage = pageNum;
      this.total = response.data.count;
      this.isLoading = false;
    },

    onPageChange(pageNum) {
      this.fetchItems(pageNum);
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },

  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.fetchItems();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
